import { FC, useEffect } from 'react'

import { RenderIf } from 'components/RenderIf'
import { useOpenNotificationsModal } from 'featureSliced/shared/hooks/openModals/useOpenNotificationsModal'
import { useOpenAppGuideModal } from 'featureSliced/shared/hooks/openAppGuideModal'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import { ReactComponent as Bell } from 'assets/cover/bellFilled.svg'
import { ReactComponent as Burger } from 'assets/cover/burgerTwoColor.svg'
import { ReactComponent as InfoIcon } from 'assets/cover/infoIconFilled.svg'

import {
  MainScreenIcon,
  MainScreenControlsContainer,
  NotificationsButtonContainer,
  SidebarButtonContainer,
} from './styled'
import { IconFull } from 'components/IconsContainers/styled'
import { getContrastColor } from 'featureSliced/shared/utils/getContrastColor'

type MainScreenControlsProps = {
  setIsSidebarShowing: (value: boolean) => void
  notificationsAmount: number | string
  getNotificationsAmount: () => void
}

export const MainScreenControls: FC<MainScreenControlsProps> = ({
  setIsSidebarShowing,
  notificationsAmount,
  getNotificationsAmount,
}) => {
  // Hooks
  const openAppGuideModal = useOpenAppGuideModal()
  const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
  const openNotificationsModal = useOpenNotificationsModal(
    getNotificationsAmount
  )

  // State
  const paymentVariant = useMySelector((state) => state.app.menu.paymentVariant)
  const selfService = useMySelector((state) => state.app.menu.selfService)
  const mainColor = useMySelector((state) => state.app.interfaceStyles.colour)
  const waiterCall = useMySelector(
    (state) => state.app.interfaceStyles.waiterCall
  )

  // useEffect
  useEffect(() => {
    if (guid || dataEnc) {
      getNotificationsAmount()
    }
  }, [guid, dataEnc])

  return (
    <MainScreenControlsContainer>
      <SidebarButtonContainer>
        <MainScreenIcon>
          <IconFull fill={getContrastColor(mainColor)} stroke="none">
            <Burger
              width="30"
              height="38"
              onClick={() => setIsSidebarShowing(true)}
            />
          </IconFull>
        </MainScreenIcon>
      </SidebarButtonContainer>

      <RenderIf condition={paymentVariant === 2 || !selfService || waiterCall}>
        <NotificationsButtonContainer
          counter={notificationsAmount}
          isCounterOffset={
            process.env.REACT_APP_IS_CLIC === '0' && paymentVariant === 2
          }
        >
          <RenderIf
            condition={
              process.env.REACT_APP_IS_CLIC === '1' ||
              (!selfService && waiterCall)
            }
          >
            <IconFull fill={mainColor} stroke="none">
              <Bell width="38" height="38" onClick={openNotificationsModal} />
            </IconFull>
          </RenderIf>
          <RenderIf
            condition={
              process.env.REACT_APP_IS_CLIC === '0' && paymentVariant === 2
            }
          >
            <IconFull fill={mainColor} stroke="none">
              <InfoIcon width="38" height="38" onClick={openAppGuideModal} />
            </IconFull>
          </RenderIf>
        </NotificationsButtonContainer>
      </RenderIf>
    </MainScreenControlsContainer>
  )
}
